module.exports = __webpack_public_path__ + "img/ic_kyc_arrows.345728e.png";